import React from 'react';
import { Row, Col, Card, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaStar, FaArrowRight } from 'react-icons/fa';

const { Title, Paragraph } = Typography;

const AIProductsSection = ({ productsData }) => {
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating || 0);
    const halfStar = rating % 1 >= 0.5 ? 1 : 0;
    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} style={{ color: '#fadb14', marginRight: '3px' }} />);
    }
    if (halfStar) {
      stars.push(<FaStar key="half" style={{ color: '#fadb14', marginRight: '3px', opacity: 0.5 }} />);
    }
    return stars;
  };

  const handleImageError = (e) => {
    e.target.src = '/images/placeholder.jpg';
  };

  return (
    <Row gutter={16}>
      <Col span={24}>
        <section style={{ marginBottom: '40px' }}>
          <Title level={2} style={{ fontSize: '18px', display: 'flex', alignItems: 'center', color: '#1890ff' }}>
            <FaShoppingCart style={{ marginRight: '8px' }} /> AI Products
          </Title>
          <Paragraph style={{ fontSize: '14px', color: '#666' }}>
            Discover cutting-edge AI tools and solutions.
          </Paragraph>
          <Row gutter={[16, 16]}>
            {(productsData.length > 0 ? productsData.slice(0, 4) : []).map((product) => (
              <Col xs={24} sm={12} md={8} lg={6} key={product.id}>
                <div className="flip-container animated-card" style={{ perspective: '1000px', height: '320px' }}>
                  <div className="flip-card">
                    <Card
                      className="flip-card-front"
                      style={{ position: 'absolute', width: '100%', height: '100%', backfaceVisibility: 'hidden', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '8px' }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        <Title level={5} style={{ marginBottom: '4px', color: '#333', textAlign: 'center', fontSize: '14px' }}>{product.name}</Title>
                        <img src={product.imageUrl} alt={`${product.name} preview`} onError={handleImageError} style={{ width: '100px', height: '100px', objectFit: 'cover', marginBottom: '4px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                        <Paragraph style={{ color: '#666', fontSize: '13px', textAlign: 'center', marginBottom: '2px' }}><strong>Seller:</strong> {product.seller}</Paragraph>
                        <div style={{ textAlign: 'center', marginBottom: '2px' }}>{renderStars(product.rating)}</div>
                        <Paragraph style={{ marginBottom: '2px', color: '#333', textAlign: 'center', fontWeight: 'bold', fontSize: '12px' }}>${product.price}</Paragraph>
                      </div>
                      <Button type="primary" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', width: '100%', marginTop: '6px', fontSize: '12px', padding: '2px 6px', height: '28px' }}>
                        <Link to="/signin">Sign In to Purchase</Link>
                      </Button>
                    </Card>
                    <Card
                      className="flip-card-back"
                      style={{ position: 'absolute', width: '100%', height: '100%', backfaceVisibility: 'hidden', transform: 'rotateY(180deg)', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', backgroundColor: '#f5f5f5', padding: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        <Title level={5} style={{ marginBottom: '4px', color: '#333', textAlign: 'center', fontSize: '14px' }}>{product.name}</Title>
                        <Paragraph style={{ color: '#666', fontSize: '13px', height: '140px', overflow: 'auto', marginBottom: '2px' }}>{product.description}</Paragraph>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <Paragraph style={{ color: '#666', fontSize: '13px', marginBottom: '2px' }}><strong>Seller:</strong> {product.seller}</Paragraph>
                        <div style={{ marginBottom: '2px' }}>{renderStars(product.rating)}</div>
                        <Paragraph style={{ marginBottom: '2px', color: '#333', fontWeight: 'bold', fontSize: '12px' }}>${product.price}</Paragraph>
                        <Button type="primary" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', width: '100%', marginTop: '6px', fontSize: '13px', padding: '2px 6px', height: '28px' }}>
                          <Link to="/signin">Sign In to Purchase</Link>
                        </Button>
                      </div>
                    </Card>
                  </div>
                </div>
              </Col>
            ))}
            {productsData.length === 0 && (
              <Col span={24}><Paragraph>No AI products available at the moment.</Paragraph></Col>
            )}
          </Row>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link to="/sell-ai-products">
              <Button type="primary" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }} aria-label="See all AI products">
                See All <FaArrowRight style={{ marginLeft: '8px' }} />
              </Button>
            </Link>
          </div>
        </section>
      </Col>
    </Row>
  );
};

export default AIProductsSection;